/* eslint-disable import/no-cycle */
import CreateUser from './CreateUser';
import EditUser from './EditUser';
import UsersList from './UsersList';
import { USER_MANAGEMENT_PERMISSION_GROUP } from '../../constants';

const userManagement = [
  { path: 'list', element: <UsersList /> },
  { path: 'create', element: <CreateUser /> },
  { path: ':id', element: <EditUser /> }
];
const GET_USER_MANAGEMENT_PATHS = (groups) => {
  if (groups?.includes(USER_MANAGEMENT_PERMISSION_GROUP)) {
    return userManagement;
  }

  return [];
};
export default GET_USER_MANAGEMENT_PATHS;
